import { useEffect, useState } from 'react';

// Fetch a Lottie animation JSON from /public at runtime instead of bundling it.
// The two login animations are 13-14MB EACH; imported from src they were baked
// into main.js, making every page (including the public campaign PIN page)
// download ~27MB of animation before anything rendered. Served from /public
// they load only where used, in parallel with render, gzip-able and cacheable.
// Returns null until loaded (or on failure) - callers keep their static
// fallbacks for both states.
export default function useLottieData(url) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!url) return undefined;
    let cancelled = false;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        if (!cancelled && json && typeof json === 'object') setData(json);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [url]);
  return data;
}
